<template>
    <div>
        <!--<div class="in-header">-->
            <!--<h2>本次测量值</h2>-->
        <!--</div>-->
        <el-form :label-position="labelPosition" label-width="120px">
            <el-form-item label="身高(cm)：">
                <el-input type="text" v-model="observed.stature" placeholder="请输入身高"></el-input>
            </el-form-item>
            <el-form-item label="体重(kg)：">
                <el-input type="text" v-model="observed.weight" placeholder="请输入体重"></el-input>
            </el-form-item>
            <el-form-item label="体温(℃)：">
                <el-input type="text" v-model="observed.animalHeat" placeholder="请输入体温"></el-input>
            </el-form-item>
            <el-form-item label="血压(mmHg)：">
                <el-input type="text" v-model="observed.bloodPressure" placeholder="请输入血压"></el-input>
            </el-form-item>
            <el-form-item label="心率(次/分钟)：">
                <el-input type="text" v-model="observed.heartRate" placeholder="请输入心率"></el-input>
            </el-form-item>
            <el-form-item label="血糖(mmol/L)：">
                <el-input type="text" v-model="observed.blood" placeholder="请输入血糖"></el-input>
            </el-form-item>
        </el-form> 

        <div class="inOne-TabBttom">
            <el-button v-if='exhibition' @click="futureSave()" type="warning"><i class="fa fa-floppy-o"></i>保存</el-button>
            <el-button v-else @click="saveData()" type="primary"><i class="fa fa-floppy-o"></i>保存</el-button>
            <el-button @click="resetData()" type="danger"><i class="fa fa-pencil" aria-hidden="true"></i>重置</el-button>
        </div>
    </div>
</template>

<style scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .in-header h2 {
        margin-bottom: 15px;
    }

    .inOne-TabBttom {
        text-align: center;
    }
</style>

<script>
  export default {
    data() {
      return {
        repetitionId:0,       // 第二次提交保存id
        uData:null,           // 用户数据对象
        exhibition:false,     // 数据展示
        labelPosition: 'left',
        observed: {
          stature: '',
          weight: '',
          animalHeat: '',
          bloodPressure: '',
          heartRate: '',
          blood:''
        }
      }
    },
    props: ['timeDate'],
    methods: {
      futureSave(){
        let that = this;
        let observed = that.observed;
        that.$confirm('确认保存吗？', '提示', {}).then(() => {
          that.$axios({
            url: "/api/inquiry/measuredvalue/" + that.repetitionId,
            method: "PUT",
            data: {
              "bloodPressure": observed.bloodPressure,
              "heartRate": observed.heartRate,
              "height": observed.stature,
              "temperature": observed.animalHeat,
              "weight": observed.weight,
              "bloodSugar":observed.blood
            }
          }).then(res => {
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消保存'
          });
        });
      },
      saveData() {         //确认按钮
        let that = this;
        let observed = that.observed;
        that.$confirm('确认保存吗？', '提示', {}).then(() => {
          that.$axios({
            url: "/api/inquiry/measuredvalue/" + that.uData.reservationId,
            method: "POST",
            data: {
              "bloodPressure": observed.bloodPressure,
              "heartRate": observed.heartRate,
              "height": observed.stature,
              "temperature": observed.animalHeat,
              "weight": observed.weight,
              "bloodSugar":observed.blood
            }
          }).then(res => {
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消保存'
          });
        });
      },
      resetData() {          //重置按钮
        let that = this
        that.$confirm('确认重置吗？', '提示', {}).then(() => {
          that.$message({
            type: 'success',
            message: '已重置了哟'
          });
          that.observed = {
            stature: '',
            weight: '',
            animalHeat: '',
            bloodPressure: '',
            heartRate: ''
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          });
        });
      },
      getData(o){
        let that = this;
        that.uData = o;
        if(o.measure == null){
          that.exhibition = false;
        }else{ 
          that.exhibition = true;
          that.repetitionId = o.measure.id;
          that.observed.stature = o.measure.height;
          that.observed.weight = o.measure.weight;
          that.observed.animalHeat = o.measure.temperature;
          that.observed.bloodPressure = o.measure.bloodPressure;
          that.observed.heartRate = o.measure.heartRate;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// inquiryChecks.vue?23febcf5